export const APA_ASSIGN_BY_CABINET_TYPE_REQUEST = 'APA_ASSIGN_BY_CABINET_TYPE_REQUEST';
export const APA_ASSIGN_BY_CABINET_TYPE_SUCCESS = 'APA_ASSIGN_BY_CABINET_TYPE_SUCCESS';
export const APA_ASSIGN_BY_CABINET_TYPE_FAIL = 'APA_ASSIGN_BY_CABINET_TYPE_FAIL';

